import { render, staticRenderFns } from "./ContactDetailedInfo.vue?vue&type=template&id=72746086&scoped=true&lang=pug&"
import script from "./ContactDetailedInfo.vue?vue&type=script&lang=js&"
export * from "./ContactDetailedInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailedInfo.vue?vue&type=style&index=0&id=72746086&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72746086",
  null
  
)

export default component.exports